import React, { useState, useEffect, useLayoutEffect } from 'react';
// import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as s from './Ethereum.style';

const Ethereum = props => {
  return (
    <s.Container>
      <s.H1>This is Ethereum Content.</s.H1>
    </s.Container>
  )
}

export default Ethereum